<template>
  <div id="app">
    <HeaderVue class="header"></HeaderVue>
      <el-main>
        <router-view></router-view>
      </el-main>
  </div>
</template>

<script>
import HeaderVue from './components/Header.vue'
export default {
  name: "App",
  components: {
    HeaderVue,
  },
  data(){
        return{
          windowWidth: document.documentElement.clientWidth,  //实时屏幕宽度
          windowHeight: document.documentElement.clientHeight,   //实时屏幕高度
        }
    },
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  min-width: 100%;
  min-height: 100%;
  position:relative;
  background-color: rgba(254, 248, 225, 0.327);
}
.header{
  height:10% !important;
  background-color: rgb(219,124,2);
}
.el-main{
  width: 85% !important;
  margin: 0 auto; 
  padding-bottom:20px !important;
}
/* 
.el-footer {
  display:flex;
  justify-content:center;
  align-items: center;
  z-index:1000;
  height: 100px!important;
  width: 100%;
  position: absolute;
  bottom: 0;
  background-color: RGB(62,58,57);
} */
.foot-link{
  width: auto;
  white-space:nowrap;
  color: white;
  text-decoration: none;
}
html, body {
  margin: 0;
  min-width: 1200px;
  min-height: 100%;
  padding: 0;
  height: 100%;
}
</style>
